import { render, staticRenderFns } from "./CentralHeatmapAtendimentosSection.vue?vue&type=template&id=70510d22&scoped=true"
import script from "./CentralHeatmapAtendimentosSection.vue?vue&type=script&lang=js"
export * from "./CentralHeatmapAtendimentosSection.vue?vue&type=script&lang=js"
import style0 from "./CentralHeatmapAtendimentosSection.vue?vue&type=style&index=0&id=70510d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70510d22",
  null
  
)

export default component.exports